<template>
    <div class="head">
        <b-container class="py-3 px-3">
            <div class="d-flex align-items-center mx-n3">
                <span role="button" aria-label="abrir menu" tabindex="0" @click.prevent="$nuxt.$emit('openMenuMobile')" class="d-lg-none pl-3" v-if="$wdconfig.modules.general.layout_mode === 'website'">
                    <b-icon icon="list" class="icon-minicart-mobile"></b-icon>
                </span>
                <div class="d-flex px-3 logo-wrapper" :class="{'justify-content-center': $wdconfig.modules.general.layout_mode === 'website'}">
                    <nuxt-link to="/" class="logo">
                        <img :src="imageUrl($wdconfig.default.logo)" :alt="$wdconfig.default.title" :title="$wdconfig.default.title" :width="$wdconfig.modules.general.logo_width" :height="$wdconfig.modules.general.logo_height" class="logo-image">
                    </nuxt-link>
                </div>
                <div class="d-flex ml-auto justify-content-end actions-wrapper">
                    <div class="d-lg-none order-md-1 pr-3" v-if="$route.path.includes('/produto') || $wdconfig.modules.general.layout_mode === 'website'">
                        <nuxt-link to="/carrinho">
                            <b-icon icon="cart" class="icon-minicart-mobile"></b-icon>
                        </nuxt-link>
                    </div>
                    <div class="flex-md-grow-1" v-if="$wdconfig.modules.search.active">
                        <div class="d-none d-md-block px-3 search">
                            <form action="/busca/" name="search">
                                <div class="input-group">
                                    <b-form-input type="search" name="q" placeholder="O que você procura?" class="search-input"></b-form-input>
                                    <div class="input-group-prepend">
                                        <button type="submit" aria-label="Buscar">
                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" width="25px" height="25px">
                                                <path d="M 21 3 C 11.601563 3 4 10.601563 4 20 C 4 29.398438 11.601563 37 21 37 C 24.355469 37 27.460938 36.015625 30.09375 34.34375 L 42.375 46.625 L 46.625 42.375 L 34.5 30.28125 C 36.679688 27.421875 38 23.878906 38 20 C 38 10.601563 30.398438 3 21 3 Z M 21 7 C 28.199219 7 34 12.800781 34 20 C 34 27.199219 28.199219 33 21 33 C 13.800781 33 8 27.199219 8 20 C 8 12.800781 13.800781 7 21 7 Z"/>
                                            </svg>
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div class="d-md-none pr-3" @click="showSearch = !showSearch" v-if="$wdconfig.modules.general.layout_mode !== 'website'">
                            <button aria-label="Buscar" class="search-btn">
                                <svg v-if="!showSearch" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" width="35px" height="20px">
                                    <path d="M 21 3 C 11.601563 3 4 10.601563 4 20 C 4 29.398438 11.601563 37 21 37 C 24.355469 37 27.460938 36.015625 30.09375 34.34375 L 42.375 46.625 L 46.625 42.375 L 34.5 30.28125 C 36.679688 27.421875 38 23.878906 38 20 C 38 10.601563 30.398438 3 21 3 Z M 21 7 C 28.199219 7 34 12.800781 34 20 C 34 27.199219 28.199219 33 21 33 C 13.800781 33 8 27.199219 8 20 C 8 12.800781 13.800781 7 21 7 Z"/>
                                </svg>
                                <svg v-else xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
                                    <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708"></path>
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="justify-content-around account d-none d-lg-flex align-items-center">
                    <div class="d-flex px-3">
                        <nuxt-link :to="$store.state.auth.person_name ? '/conta/meus-dados/' : '/login/'" class="d-flex align-items-center">
                            <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 28.328 28.328">
                                <path class="a" d="M28.328,14.164A14.164,14.164,0,1,0,14.164,28.328,14.156,14.156,0,0,0,28.328,14.164ZM14.164,1.66a12.506,12.506,0,0,1,10.363,19.5,14.158,14.158,0,0,0-20.725,0A12.506,12.506,0,0,1,14.164,1.66ZM4.836,22.49a12.5,12.5,0,0,1,18.655,0A12.492,12.492,0,0,1,4.836,22.49Zm0,0"/>
                                <path class="a" d="M170.979,72.619a4.985,4.985,0,0,0,4.979-4.979v-1.66a4.979,4.979,0,1,0-9.959,0v1.66A4.985,4.985,0,0,0,170.979,72.619Zm-3.32-6.639a3.32,3.32,0,1,1,6.639,0v1.66a3.32,3.32,0,1,1-6.639,0Zm0,0" transform="translate(-156.816 -57.625)"/>
                            </svg>
                            <div v-if="$store.state.auth.person_name" class="logged">
                                <div>Olá, {{ $store.state.auth.person_name.split(' ')[0] }}</div>
                                <div>
                                    Minha conta
                                </div>
                            </div>
                            <div class="login-register" v-else>
                                Entre ou cadastre-se
                            </div>
                        </nuxt-link>
                    </div>
                    <div class="px-3">
                        <MiniCart/>
                    </div>
                </div>
            </div>
            <div class="mt-3 d-md-none search" v-if="showSearch || $wdconfig.modules.general.layout_mode === 'website'">
                <form action="/busca/" name="search">
                    <div class="input-group">
                        <b-form-input type="search" name="q" placeholder="O que você procura?" size="sm" class="search-input"></b-form-input>
                        <div class="input-group-prepend">
                            <button type="submit" aria-label="Buscar">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" width="22px" height="22px">
                                    <path d="M 21 3 C 11.601563 3 4 10.601563 4 20 C 4 29.398438 11.601563 37 21 37 C 24.355469 37 27.460938 36.015625 30.09375 34.34375 L 42.375 46.625 L 46.625 42.375 L 34.5 30.28125 C 36.679688 27.421875 38 23.878906 38 20 C 38 10.601563 30.398438 3 21 3 Z M 21 7 C 28.199219 7 34 12.800781 34 20 C 34 27.199219 28.199219 33 21 33 C 13.800781 33 8 27.199219 8 20 C 8 12.800781 13.800781 7 21 7 Z"/>
                                </svg>
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </b-container>
        <LazyHydrate when-visible>
            <MegaMenu class="d-none d-lg-block"/>
        </LazyHydrate>
    </div>
</template>
<script>
    import Cookies from 'js-cookie';
    import MiniCart from "~/components/MiniCart";
    import MegaMenu from "~/components/MegaMenu/MegaMenu";
    import utils from "~/mixins/utils";
    import LazyHydrate from 'vue-lazy-hydration';

    export default {
        components: {
            MegaMenu,
            MiniCart,
            LazyHydrate
        },
        mixins: [
            utils
        ],
        data() {
            return {
                isAuth: false,
                location: '',
                showSearch: false
            }
        },
        mounted() {
            window.addEventListener('scroll', this.updateScroll)
            if (this.$route.query.location === 'true') {
                sessionStorage.setItem('wdshop_location', this.$route.query.location)
            }
            if (sessionStorage.getItem('wdshop_location') === 'true') {
                this.$wdconfig.locations.map((elem) => {
                    if (elem.link === '/') {
                        Cookies.get('modal_location', elem.name)
                    }
                })
            }
            this.location = Cookies.get('modal_location') || false
        }
    }
</script>
